/* eslint-disable react/prop-types */
// import { PropTypes } from "prop-types";

import React from "react";
import { graphql } from "gatsby";
import BrandShelf from "~components/BrandShelf";
import Footer from "~components/Footer";
import Layout from "~components/Layout";
import SEO from "~components/SEO";
import { sortArrayByPriority } from "~utils/helpers";

const BrandsPage = ({ data, location }) => {
  const cms = data.sanityBrandIndex;

  const brands = [];

  data.allSanityBrand.edges.forEach(({ node }) => {
    brands.push(node);
  });

  sortArrayByPriority(brands);

  //

  return (
    <>
      <SEO
        customTitle={cms?.title}
        customDescription={cms?.seoDescription}
        customKeywords={cms?.seoKeywords}
        path={location.pathname}
      />

      <Layout className="brands-page w-full relative pt-v7 bg-bone">
        {brands.map((brand, brandIndex) => {
          return (
            <section
              key={brand.title}
              className="animation-appear-down-slow"
              style={{ animationDelay: `${brandIndex * 100 + 100}ms` }}
            >
              <BrandShelf brand={brand} />
            </section>
          );
        })}
      </Layout>

      <Footer />
    </>
  );
};

export default BrandsPage;

export const query = graphql`
  query BrandsPage {
    sanityBrandIndex {
      title
      seoDescription
      seoKeywords
    }

    allSanityBrand {
      edges {
        node {
          title
          handle
          priority
          description
          tagline
          image {
            asset {
              fluid {
                ...GatsbySanityImageFluid_noBase64
              }
            }
            altText
          }
        }
      }
    }

    allSanityCollection {
      edges {
        node {
          title
          handle
          description
        }
      }
    }
  }
`;
